import { render, staticRenderFns } from "./HomeLg.vue?vue&type=template&id=72408d44&scoped=true&"
import script from "./HomeLg.vue?vue&type=script&lang=js&"
export * from "./HomeLg.vue?vue&type=script&lang=js&"
import style0 from "./HomeLg.vue?vue&type=style&index=0&id=72408d44&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72408d44",
  null
  
)

export default component.exports